import GroupManagement from './GroupManagement';
import RoleManagement from './RoleManagement';
import SKDMaster from './SKDMaster';
import ReadQR from './ReadQR';

const services = {
  GroupManagement,
  RoleManagement,
  SKDMaster,
  ReadQR,
};

export default services;
